<template>
    <div class="not-found">
        <img src="https://www.myphukettravel.com/assets/front-end/images/404.gif" alt="404 Not Found"
            class="not-found__image" />
        <router-link to="/" class="not-found__button">
            BACK HOME
        </router-link>
    </div>
</template>

<script setup>
</script>

<style scoped>
    .not-found {
        min-height: 100vh;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .not-found__image {
        max-width: 500px;
        width: 100%;
    }

    .not-found__button {
        margin-top: 24px;
        padding: 12px 24px;
        background-color: #000;
        color: #fff;
        text-decoration: none;
        font-weight: 600;
        border-radius: 4px;
    }
</style>